import * as React from "react";
import {Fragment} from "react";
import LeadWatcherChangeNotification from "../../../model/notification/watcher/LeadWatcherChangeNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: LeadWatcherChangeNotification
}

/**
 * Lead watcher change notification toast body.
 */
const NotificationLeadWatcherChangeBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.getLeadReferenceNumber()}</div>
			<div className={"toast-body"}>
				Watcher(s) changed from <b>{props.notification.displayPreviousWatchers()} </b>
				to <b>{props.notification.displayCurrentWatchers()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationLeadWatcherChangeBody;